import { getCLS } from './cls/getCLS.tsx';
import { PerformanceObserverEntryTypes } from './PerformanceObserverEntryTypes.tsx';
import { getTBT } from './tbt/getTBT.tsx';
import { EntriesBuffer } from './utils/buffer/BufferWithMaxLength.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { startLSObserver, startLTObserver } from './utils/observer/startLSObserver.tsx';
export const getLighthouseMetrics = ({
	start,
	stop,
}: {
	start: number;
	stop: number;
}): { [key: string]: number } => {
	const tbt = getTBT(start, stop, EntriesBuffer[PerformanceObserverEntryTypes.LongTask]);

	// no round as CLS is usually 0-1
	const cls = getCLS(start, stop, EntriesBuffer[PerformanceObserverEntryTypes.LayoutShift]);
	return {
		'metric:tbt': Math.round(tbt.total),
		'metric:tbt:observed': Math.round(tbt.observed),
		'metric:cls': cls,
	};
};
